import { useQuery } from "@tanstack/react-query";
import adminApiClient, { EcoModeStatsResponse } from "api/admin";

export default function useEcoModeStats(fromVersion?: number) {
  return useQuery<EcoModeStatsResponse>({
    queryKey: ["ecoModeStats", fromVersion],
    queryFn: () => adminApiClient.getEcoModeStats(fromVersion),
  });
}
